import user from './server/user/user';
import caregiver from './server/caregiver/caregiver';
import client from './server/client/client';
import clientLead from './server/client_lead/client_lead';
import clientSupport from './server/client_support/client_support';
import event from './server/schedule/event';
import paymentSlip from './server/payment/slip';
import holiday from './server/payment/holiday';
import expenseReimbursement from './server/payment/expense_reimbursement';
import clientPaymentPlan from './server/client/payment_plan/payment_plan';
import caregiverPaymentPlan from './server/caregiver/payment_plan/payment_plan';
import fileStorage from './server/file_storage/file_storage';
import career from './server/career/career';
import metrics from './server/metrics/metrics';
import notification from './server/notification/notification';
import communication from './server/communication/communication';
import dialpadIntegration from './server/dialpad_integration/dialpad_integration';
import playbook from './server/playbook/playbook';
import skills from './server/skill/skill';
import workflow from './server/workflow/workflow';
import task from './server/task/task';
import caseApi from './server/case/case';
import domainGuide from './server/domain_guide/domain_guide';
import routine from './server/routine/routine';
import agentChat from './server/agent_chat/agent_chat';
import agentJobs from './server/agent_jobs/agent_jobs';
import s3 from './aws/s3';

export default {
  s3,
  routine,
  user,
  caregiver,
  client,
  clientLead,
  clientSupport,
  career,
  event,
  paymentSlip,
  holiday,
  clientPaymentPlan,
  caregiverPaymentPlan,
  fileStorage,
  expenseReimbursement,
  metrics,
  notification,
  communication,
  dialpadIntegration,
  playbook,
  skills,
  workflow,
  task,
  case: caseApi,
  domainGuide,
  routine,
  agentChat,
  agentJobs,
};
